
//Native Number Icons
import Nat_Num_0_10 from "../../assets/DeckCards/Numbers/Nat_Num_0_10.png";
import Nat_Num_11_19 from "../../assets/DeckCards/Numbers/Nat_Num_11_19.png";
import Nat_Num_20_29 from "../../assets/DeckCards/Numbers/Nat_Num_20_29.png";
import Nat_Num_30_39 from "../../assets/DeckCards/Numbers/Nat_Num_30_39.png";
import Nat_Num_40_49 from "../../assets/DeckCards/Numbers/Nat_Num_40_49.png";
import Nat_Num_50_59 from "../../assets/DeckCards/Numbers/Nat_Num_50_59.png";
import Nat_Num_60_69 from "../../assets/DeckCards/Numbers/Nat_Num_60_69.png";
import Nat_Num_70_79 from "../../assets/DeckCards/Numbers/Nat_Num_70_79.png";
import Nat_Num_80_89 from "../../assets/DeckCards/Numbers/Nat_Num_80_89.png";
import Nat_Num_90_99 from "../../assets/DeckCards/Numbers/Nat_Num_90_99.png";
import Nat_Num_100_900 from "../../assets/DeckCards/Numbers/Nat_Num_100_900.png";
import Nat_Num_1000_9000 from "../../assets/DeckCards/Numbers/Nat_Num_1000_9000.png";
import Nat_Num_10000_plus from "../../assets/DeckCards/Numbers/Nat_Num_10000_plus.png";


//Sino Number Icons
import Sino_Num_0_10 from "../../assets/DeckCards/Numbers/Sino_Num_0_10.png";
import Sino_Num_11_19 from "../../assets/DeckCards/Numbers/Sino_Num_11_19.png";
import Sino_Num_20_29 from "../../assets/DeckCards/Numbers/Sino_Num_20_29.png";
import Sino_Num_30_39 from "../../assets/DeckCards/Numbers/Sino_Num_30_39.png";
import Sino_Num_40_49 from "../../assets/DeckCards/Numbers/Sino_Num_40_49.png";
import Sino_Num_50_59 from "../../assets/DeckCards/Numbers/Sino_Num_50_59.png";
import Sino_Num_60_69 from "../../assets/DeckCards/Numbers/Sino_Num_60_69.png";
import Sino_Num_70_79 from "../../assets/DeckCards/Numbers/Sino_Num_70_79.png";
import Sino_Num_80_89 from "../../assets/DeckCards/Numbers/Sino_Num_80_89.png";
import Sino_Num_90_99 from "../../assets/DeckCards/Numbers/Sino_Num_90_99.png";
import Sino_Num_100_900 from "../../assets/DeckCards/Numbers/Sino_Num_100_900.png";
import Sino_Num_1000_9000 from "../../assets/DeckCards/Numbers/Sino_Num_1000_9000.png";
import Sino_Num_10000_plus from "../../assets/DeckCards/Numbers/Sino_Num_10000_plus.png";

//Native Numbers
export const NativeNumbersDeckFace = [
    {
        id: "num__nat_0_10",
        Title: "Native Numbers: 1-10",
        Description: "Learn to count from 1 to 10!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_0_10,
        Link: "/Nat_Num_0_10_Deck",
        cssId: "num-1-10-ID"
    },
    {
        id: "num_nat_11_19",
        Title: "Native Numbers: 11-19",
        Description: "Learn to count from 11 to 19!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_11_19,
        Link: "/Nat_Num_11_19_Deck",
        cssId: "num-11-19-ID"
    },
    {
        id: "num_nat_20_29",
        Title: "Native Numbers: 20-29",
        Description: "Learn to count from 20 to 29!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_20_29,
        Link: "/Nat_Num_20_29_Deck",
        cssId: "num-20-29-ID"
    },
    {
        id: "num_nat_30_39",
        Title: "Native Numbers: 30-39",
        Description: "Learn to count from 30 to 39!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_30_39,
        Link: "/Nat_Num_30_39_Deck",
        cssId: "num-30-39-ID"
    },
    {
        id: "num_nat_40_49",
        Title: "Native Numbers: 40-49",
        Description: "Learn to count from 40 to 49!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_40_49,
        Link: "/Nat_Num_40_49_Deck",
        cssId: "num-40-49-ID"
    },
    {
        id: "num_nat_50_59",
        Title: "Native Numbers: 50-59",
        Description: "Learn to count from 50 to 59!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_50_59,
        Link: "/Nat_Num_50_59_Deck",
        cssId: "num-50-59-ID"
    },
    {
        id: "num_nat_60_69",
        Title: "Native Numbers: 60-69",
        Description: "Learn to count from 60 to 69!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_60_69,
        Link: "/Nat_Num_60_69_Deck",
        cssId: "num-60-69-ID"
    },
    {
        id: "num_nat_70_79",
        Title: "Native Numbers: 70-79",
        Description: "Learn to count from 70 to 79!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_70_79,
        Link: "/Nat_Num_70_79_Deck",
        cssId: "num-70-79-ID"
    },
    {
        id: "num_nat_80_89",
        Title: "Native Numbers: 80-89",
        Description: "Learn to count from 80 to 89!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_80_89,
        Link: "/Nat_Num_80_89_Deck",
        cssId: "num-nat-80-89-ID"
    },
    {
        id: "num_nat_90_99",
        Title: "Native Numbers: 90-99",
        Description: "Learn to count from 90 to 99!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_90_99,
        Link: "/Nat_Num_90_99_Deck",
        cssId: "num-nat-90-99-ID"
    },
    {
        id: "num_nat_100_900",
        Title: "Native Numbers: 100-900",
        Description: "Learn to count from 100 to 900!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_100_900,
        Link: "/Nat_Num_100_900_Deck",
        cssId: "num-nat-100-900-ID"
    },
    {
        id: "num_nat_1000_9000",
        Title: "Native Numbers: 1,000-9,000",
        Description: "Learn to count from 1,000 to 9,000!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_1000_9000,
        Link: "/Nat_Num_1000_9000_Deck",
        cssId: "num-nat-1000-9000-ID"
    },
    {
        id: "num_nat_10000_plus",
        Title: "Native Numbers: 10,000+",
        Description: "Learn to count to 10,000+!",
        Difficulty: "Beginner 2",
        Image: Nat_Num_10000_plus,
        Link: "/Nat_Num_10000_plus_Deck",
        cssId: "num-nat-10000-plus-ID"
    },
]


//Sino Numbers
export const SinoNumbersDeckFace = [
    {
        id: "num_sino_0_10",
        Title: "Sino Numbers: 0-10",
        Description: "Learn to count from 0 to 10!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_0_10,
        Link: "/Sino_Num_0_10_Deck",
        cssId: "num-sino-0-10-ID"
    },
    {
        id: "num_sino_11_19",
        Title: "Sino Numbers: 11-19",
        Description: "Learn to count from 11 to 19!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_11_19,
        Link: "/Sino_Num_11_19_Deck",
        cssId: "num-sino-11-19-ID"
    },
    {
        id: "num_sino_20_29",
        Title: "Sino Numbers: 20-29",
        Description: "Learn to count from 20 to 29!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_20_29,
        Link: "/Sino_Num_20_29_Deck",
        cssId: "num-sino-20-29-ID"
    },
    {
        id: "num_sino_30_39",
        Title: "Sino Numbers: 30-39",
        Description: "Learn to count from 30 to 39!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_30_39,
        Link: "/Sino_Num_30_39_Deck",
        cssId: "num-sino-30-39-ID"
    },
    {
        id: "num_sino_40_49",
        Title: "Sino Numbers: 40-49",
        Description: "Learn to count from 40 to 49!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_40_49,
        Link: "/Sino_Num_40_49_Deck",
        cssId: "num-sino-40-49-ID"
    },
    {
        id: "num_sino_50_59",
        Title: "Sino Numbers: 50-59",
        Description: "Learn to count from 50 to 59!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_50_59,
        Link: "/Sino_Num_50_59_Deck",
        cssId: "num-sino-50-59-ID"
    },
    {
        id: "num_sino_60_69",
        Title: "Sino Numbers: 60-69",
        Description: "Learn to count from 60 to 69!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_60_69,
        Link: "/Sino_Num_60_69_Deck",
        cssId: "num-sino-60-69-ID"
    },
    {
        id: "num_sino_70_79",
        Title: "Sino Numbers: 70-79",
        Description: "Learn to count from 70 to 79!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_70_79,
        Link: "/Sino_Num_70_79_Deck",
        cssId: "num-sino-70-79-ID"
    },
    {
        id: "num_sino_80_89",
        Title: "Sino Numbers: 80-89",
        Description: "Learn to count from 80 to 89!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_80_89,
        Link: "/Sino_Num_80_89_Deck",
        cssId: "num-sino-80-89-ID"
    },
    {
        id: "num_sino_90_99",
        Title: "Sino Numbers: 90-99",
        Description: "Learn to count from 90 to 99!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_90_99,
        Link: "/Sino_Num_90_99_Deck",
        cssId: "num-sino-90-99-ID"
    },
    {
        id: "num_sino_100_900",
        Title: "Sino Numbers: 100-900",
        Description: "Learn to count from 100 to 900!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_100_900,
        Link: "/Sino_Num_100_900_Deck",
        cssId: "num-sino-100-900-ID"
    },
    {
        id: "num_sino_1000_9000",
        Title: "Sino Numbers: 1,000-9,000",
        Description: "Learn to count from 1,000 to 9,000!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_1000_9000,
        Link: "/Sino_Num_1000_9000_Deck",
        cssId: "num-sino-1000-9000-ID"
    },
    {
        id: "num_sino_10000_plus",
        Title: "Sino Numbers: 10,000+",
        Description: "Learn to count to 10,000+!",
        Difficulty: "Beginner 2",
        Image: Sino_Num_10000_plus,
        Link: "/Sino_Num_10000_plus_Deck",
        cssId: "num-sino-10000-plus-ID"
    },
]

